var $173e9fb4d14fe309$exports = {};
$173e9fb4d14fe309$exports = {
  "breadcrumbs": "Atpaka\u013Cce\u013Ci"
};
export { $173e9fb4d14fe309$exports as default };